'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _echarts = require('echarts/lib/echarts');

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function noop() {}

var ECahrts = function (_Component) {
  _inherits(ECahrts, _Component);

  function ECahrts() {
    _classCallCheck(this, ECahrts);

    return _possibleConstructorReturn(this, (ECahrts.__proto__ || Object.getPrototypeOf(ECahrts)).apply(this, arguments));
  }

  _createClass(ECahrts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          option = _props.option,
          notMerge = _props.notMerge,
          lazyUpdate = _props.lazyUpdate,
          theme = _props.theme,
          initOption = _props.initOption,
          getInstance = _props.getInstance,
          events = _objectWithoutProperties(_props, ['loading', 'option', 'notMerge', 'lazyUpdate', 'theme', 'initOption', 'getInstance']);

      this.instance = _echarts2.default.init(this.dom, theme, initOption);
      Object.keys(events).filter(isEventName).forEach(function (e) {
        if (typeof events[e] === 'function') _this2.instance.on(toEChartsEventName(e), events[e]);
      });
      if (loading) this.instance.showLoading();
      if (option) this.instance.setOption(option, notMerge, lazyUpdate);
      getInstance(this.instance);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var _this3 = this;

      var option = _ref.option,
          notMerge = _ref.notMerge,
          lazyUpdate = _ref.lazyUpdate,
          loading = _ref.loading,
          events = _objectWithoutProperties(_ref, ['option', 'notMerge', 'lazyUpdate', 'loading']);

      if (option !== this.props.option) this.instance.setOption(option, notMerge, lazyUpdate);
      if (loading !== this.props.loading) {
        if (loading) this.instance.showLoading();else this.instance.hideLoading();
      }

      // bind or unbind events
      var props = this.props;
      Object.keys(props).filter(isEventName).forEach(function (e) {
        if (props[e] !== events[e] && typeof props[e] === 'function') _this3.instance.off(toEChartsEventName(e), props[e]);
      });
      Object.keys(events).filter(isEventName).forEach(function (e) {
        if (events[e] !== props[e] && typeof events[e] === 'function') _this3.instance.on(toEChartsEventName(e), events[e]);
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref2) {
      var className = _ref2.className,
          style = _ref2.style,
          width = _ref2.width,
          height = _ref2.height;

      return className !== this.props.className || style !== this.props.style || width !== this.props.width || height !== this.props.height;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.instance.resize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.instance.dispose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          className = _props2.className,
          style = _props2.style,
          width = _props2.width,
          height = _props2.height;

      return _react2.default.createElement('div', { ref: function ref(dom) {
          return _this4.dom = dom;
        }, className: className, style: _extends({}, style, { width: width, height: height }) });
    }
  }]);

  return ECahrts;
}(_react.Component);

ECahrts.defaultProps = {
  getInstance: noop,
  notMerge: false,
  lazyUpdate: false
};
exports.default = ECahrts;


function toEChartsEventName(eventName) {
  return eventName.slice(2).toLowerCase();
}

function isEventName(k) {
  return k.startsWith('on') && k.charAt(2) <= 'Z';
}


//////////////////
// WEBPACK FOOTER
// /mnt/f/projects/react-echarts3/dist/index.js
// module id = 164
// module chunks = 0